import React, { Component } from 'react';
import Page from '@ui/components/ams/Pages/Page';
import AMS from '@ui/components/ams';
import { PAGE_CATEGORY } from '@lib/constants';
import { pushPageViewEvent } from '@lib/atm';
import { withServerSideProps } from '@lib/withServerSideProps';
import { categoryDetailsPageQuery } from '@queries/pages/categoryDetails';

class CategoryDetails extends Component {
  PAGE_NAME = 'category';

  componentDidMount() {
    const {
      userSessionData: {
        userData,
      },
      locale,
      pageData,
    } = this.props;
    const {
      category: [currentCategory],
      category: [
        {
          name: pageTitle
        }
      ]
    } = pageData;
    const {
      location: {
        search: currentSearch,
      }
    } = window;
    const searchParams = new URLSearchParams(currentSearch || '');
    const selectedSubCategorySlug = searchParams.getAll('subCategory')[0] || '';
    const selectedSubCategory = (currentCategory.subCategories || []).find(
      ({ slug }) => slug === selectedSubCategorySlug
    );

    pushPageViewEvent(
      window,
      userData,
      {
        locale,
        sections: [
          this.PAGE_NAME,
          currentCategory.analyticsSlug,
          selectedSubCategory?.analyticsSlug
        ],
        title: pageTitle
      }
    );
  }

  render() {
    const {
      pageData,
      locale,
      requestData,
      userSessionData,
      globalPageData,
    } = this.props;

    const {
      category,
      globalCategoryConfig = {},
      pageAds,
    } = pageData;

    const categoryData = category?.[0] ?? {};
    const pageTitle = categoryData.name || '';

    return (
      <Page
        pageName={PAGE_CATEGORY}
        pageTitle={pageTitle}
        metaDescription={categoryData.metaDescription}
        globalPageData={globalPageData}
        requestData={requestData}
        userSessionData={userSessionData}
        pageAds={pageAds}
      >
        <AMS.CategoryPage
          {...categoryData}
          {...globalCategoryConfig}
          locale={locale}
        />
      </Page>
    );
  }
}

export const getServerSideProps = withServerSideProps({
  pageQuery: categoryDetailsPageQuery,
  getPageQueryVariables: ({ query }) => ({
    categorySlug: query.categorySlug,
    adsPageSlug: query.adsPageSlug,
  }),
});

export default CategoryDetails;
